import { render } from "./ExpeditionOrdersComponent.vue?vue&type=template&id=61ef4ece"
import script from "./ExpeditionOrdersComponent.vue?vue&type=script&lang=js"
export * from "./ExpeditionOrdersComponent.vue?vue&type=script&lang=js"

import "./ExpeditionOrdersComponent.vue?vue&type=style&index=0&id=61ef4ece&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\D_A\\Lockers\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__